var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mh-style-picker" }, [
    _c("div", { staticClass: "mh-style-picker__header" }, [
      _c("i", { staticClass: "fa fa-image mh-style-picker__header-icon" }),
      _vm._v(" "),
      _c("span", [
        _c("b", [_vm._v(_vm._s(_vm.header))]),
        _vm._v(" · pick a style"),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mh-style-picker__cards" },
      _vm._l(_vm.cards, function (card) {
        return _c(
          "button",
          {
            key: card.key,
            staticClass: "mh-style-picker__card",
            class: { "is-selected": _vm.selectedAction === card.action },
            attrs: {
              type: "button",
              disabled: _vm.disabled || !!_vm.selectedAction,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("action", card.action)
              },
            },
          },
          [
            _c("img", {
              staticClass: "mh-style-picker__card-thumb",
              attrs: { src: card.thumbnail, alt: card.title },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "mh-style-picker__card-title" }, [
              _vm._v("\n        " + _vm._s(card.title) + "\n      "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mh-style-picker__card-subtitle" }, [
              _vm._v("\n        " + _vm._s(card.subtitle) + "\n      "),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.skipAction
      ? _c(
          "button",
          {
            staticClass: "mh-style-picker__skip",
            attrs: {
              type: "button",
              disabled: _vm.disabled || !!_vm.selectedAction,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("action", _vm.skipAction)
              },
            },
          },
          [_vm._v("\n    " + _vm._s(_vm.skipLabel) + "\n  ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }